import React from 'react';
import {useMatch} from 'react-router-dom';
import {ROUTES} from '@/config/routesConstants';
import MessagesSidePanel from '@/components/messages-side-panel';
import useAgencyQuery from '@/hooks/queries/use-agency-query';
import useCollaborationConversation from '@/hooks/queries/use-collaboration-conversation/useCollaborationConversation';
import useConversationDetailsQuery from '@/hooks/queries/use-conversation-details-query/useConversationDetailsQuery';
import useCreatorProfileQuery from '@/hooks/queries/use-creator-profile-query';
import useBrandId from '@/hooks/use-brand-id';
import useMessagingPanel from '@/hooks/use-messaging-panel';

function GlobalMessagingPanel() {
  const {isOpen, creatorId, close} = useMessagingPanel();
  const brandId = useBrandId() ?? '';
  const {currentBrand} = useAgencyQuery({brandId});
  // useParams() returns {} when rendered outside <Routes> (e.g. in MainRoutes layout).
  // useMatch() checks the current URL directly and works at any tree depth.
  const campaignV2Match = useMatch(`${ROUTES.CAMPAIGNS_V2}/:campaignId/*`);
  const campaignMatch = useMatch(`${ROUTES.CAMPAIGNS}/:campaignId/*`);
  const campaignId =
    (campaignV2Match ?? campaignMatch)?.params.campaignId ?? undefined;

  const {profile} = useCreatorProfileQuery({
    profileId: creatorId,
    brandId,
    enabled: !!creatorId && !!brandId,
  });

  const {conversationId, isLoading: isConversationLoading} =
    useCollaborationConversation({
      creatorId: creatorId ?? '',
      brandId,
      enabled: !!creatorId && !!brandId,
    });

  const {campaignConversations, isLoading: isCampaignConversationsLoading} =
    useConversationDetailsQuery(
      campaignId && conversationId ? conversationId : null,
      brandId
    );

  const matchedCampaignConversation = campaignConversations.find(
    (c) => c.campaign.id === campaignId
  );
  const merchantConversationId = matchedCampaignConversation?.id ?? null;
  const campaignName = matchedCampaignConversation?.campaign.name ?? undefined;

  const isEffectiveConversationLoading =
    isConversationLoading || (!!campaignId && isCampaignConversationsLoading);

  const effectiveConversationId =
    (campaignId && merchantConversationId
      ? merchantConversationId
      : conversationId) ?? '';

  return (
    <MessagesSidePanel
      isOpen={isOpen}
      onClose={close}
      creatorName={profile?.displayName ?? ''}
      conversationId={
        isEffectiveConversationLoading ? null : effectiveConversationId
      }
      brandId={brandId}
      brandName={currentBrand?.name ?? ''}
      campaignName={campaignName}
      campaignId={campaignId}
    />
  );
}

export default GlobalMessagingPanel;
